import { BaseEditItemStore } from "@leap4/frontend";
import {IUser} from "./EditUser";

export class EditUserStore extends BaseEditItemStore<IUser>{
    entityName: string = "User";
}